import React from "react";
import * as notify from "../../../../shared/notify";
import { saveNewOption } from "../lib/data";

const Creatable = (props) => {
    const addNewOption = async (e) => {
        e.stopPropagation();
        e.preventDefault();

        // Validation Length Restriction
        if (props.lengthRestriction && props.value.length > props.lengthRestriction) {
            notify.error(`Character count must be no more than ${props.lengthRestriction}`);

            return;
        }

        const newOption = await saveNewOption(props.value, props.provider, props.tags);

        if (!newOption) {
            props.onSelect("");

            return;
        }

        props.onSelect(newOption);
        notify.success("Option added");
    };

    return (
        <div className="dropdown-item -create" onClick={addNewOption}>
            <p>
                Create: <strong>{props.value}</strong>
            </p>
        </div>
    );
};

export default Creatable;
